import { Card, Grid, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';
import {
  Chart as ChartJS,
  Legend,
  LinearScale,
  PointElement,
  Tooltip,
} from 'chart.js';
import { Bubble } from 'react-chartjs-2';
import { fontsize15, poppins600 } from 'theme/common.style';
import { useCallback, useRef, useState, useEffect } from 'react';

ChartJS.register(LinearScale, PointElement, Tooltip, Legend);

function BubbleChart({ sector, list }) {
  const [InspectedCountval, setInspectedCountval] = useState(true);
  const [SimilarInspectedAvgCountval, setSimilarInspectedAvgCountval] =
    useState(true);
  let datalabel = ['Week0'];
  sector?.rightColumn?.forEach((item) => {
    datalabel.push('Week' + item.week);
  });

  const theme = useTheme();
  const matches500 = useMediaQuery(theme.breakpoints.down(500));

  let offersCount = [0];
  let similarAvgMaxOfferPrice = [0];

  sector?.rightColumn?.forEach((item) => {
    offersCount.push(item.maxOfferPrice);
  });
  sector?.rightColumn?.forEach((item) => {
    similarAvgMaxOfferPrice.push(item.similarAvgMaxOfferPrice);
  });

  // const data = {
  //     datasets: [
  //       {
  //       label: 'OffersCount',
  //       data: [{
  //         x: datalabel,
  //         y: offersCount,
  //       },

  //     ],

  //       backgroundColor: 'blue'
  //     },
  //     {
  //       label: 'SimilarAvgMaxOfferPrice',
  //       data: [{
  //         x: datalabel,
  //         y: similarAvgMaxOfferPrice,
  //       },
  //     ],

  //       backgroundColor: 'pink'
  //     },
  //   ]
  //   };
  useEffect(() => {
    if (!list?.length) return;
    list.forEach((item) => {
      if (item?.dataset == 'Inspected Count') {
        setInspectedCountval(item?.visible);
      }

      if (item?.dataset == 'Similar Inspected Avg Count') {
        setSimilarInspectedAvgCountval(item?.visible);
      }
    });
  }, [list]);

  const data = {
    datasets: [
      InspectedCountval && {
        label: 'Max OfferPrice',
        data: sector?.rightColumn?.map((item) => ({
          x: 'Week' + item.week,
          y: item.maxOfferPrice,
          r: 7,
        })),
        borderColor: 'rgb(75, 192, 192)',
        backgroundColor: 'rgb(75, 192, 192, 0.2)',
        // fontSize: matches500 ? "8px" : undefined,
        borderWidth: 2,
      },
      SimilarInspectedAvgCountval && {
        label: 'Similar Average Max OfferPrice',
        data: sector?.rightColumn?.map((item) => ({
          x: 'Week' + item.week,
          y: item.similarAvgMaxOfferPrice,
          r: 7,
        })),
        borderColor: 'rgb(153, 102, 255)',
        backgroundColor: 'rgb(153, 102, 255, 0.2)',
        // fontSize: matches500 ? "8px" : undefined,
        borderWidth: 2,
      },
    ].filter(Boolean),
    // datasets: [{
    //   label: 'Dataset 2',
    //   data:sector.map(item => ({ x: "Week"+item.week, y: item.similarAvgMaxOfferPrice , r:2})),

    //   backgroundColor: 'red'
    // }]
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        callbacks: {
          title: (items) => items?.[0]?.label ?? '',
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false, // ❌ remove vertical grid lines
          drawBorder: false,
        },
        ticks: {
          display: true, // keep numbers if you want
        },
        type: 'category',
        // labels: datalabel,
      },
      y: {
        grid: {
          display: false, // ❌ remove horizontal grid lines
          drawBorder: false,
        },
        ticks: {
          display: true, // keep labels
        },
      },
    },
  };

  const [downloadBubbleChart, setDownloadBubbleChart] = useState();
  let ref = useRef(null);

  const DownloadImg = useCallback(() => {
    const link = document.createElement('a');
    link.download = 'BubbleChart.png';
    link.href = ref.current.toBase64Image();
    setDownloadBubbleChart(ref.current.toBase64Image());
    //   link.click();
  });

  useEffect(() => {
    if (ref.current) {
      DownloadImg();
    }
  }, []);

  return (
    <Grid
      sx={{
        display: 'flex',
        paddingTop: '5px',
        minWidth: '100%',
        height: '100%',
      }}
    >
      <Card
        sx={{
          borderRadius: '8px',
          padding: '15px',
          height: '100%',
          boxShadow: 'none',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
          backgroundColor: '#fff',
        }}
      >
        <Typography
          sx={{ ...poppins600, fontSize: matches500 ? '12px' : undefined }}
        >
          Campaign vs Market Status
        </Typography>

        {/*  CHART CONTAINER */}
        <Grid
          sx={{
            flex: 1,
            minHeight: 0,
          }}
        >
          <Bubble ref={ref} data={data} options={options} />
        </Grid>
      </Card>
    </Grid>
  );
}

export default BubbleChart;
